import { keepPreviousData } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import { apiHelper } from "app/common/services/apiHelper";
import { useSiteInfo } from "app/services/sitesService/hooks/useSiteInfo";
import type { ISiteInfoParams } from "app/services/sitesService/types";

const useSiteMetaInfo = (key: string, country: number | string, isActivationLoading?: boolean) => {
    const apiParams: ISiteInfoParams = apiHelper.transformParamsForAPI({
        key,
        country,
    }) as ISiteInfoParams;

    return useSiteInfo(apiParams, undefined, {
        enabled: !isActivationLoading && !!key,
        placeholderData: keepPreviousData,
        throwOnError: true,
        onError: (error: Error) => {
            Sentry.error(`Error fetching site meta info for activation home -`, error);
        },
    });
};

export default useSiteMetaInfo;
